module.exports = __webpack_public_path__ + "media/recipes/3-43e37c15.png";